<div class="flex flex-col mt-4 sm:mt-0 px-4 sm:px-0">
  <soft-date-range-picker
    class="date-picker"
    [value]="value()"
    (valueChange)="onValueChange($event)"
    [shortcuts]="shortcuts()"
    #picker
  >
  </soft-date-range-picker>
</div>
